// extracted by mini-css-extract-plugin
export default {"kakao_link_button":"KakaoLinkButton_kakao_link_button__7NGx0"};